<div class="container-fluid cw-background">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1 col-lg-4 col-lg-offset-4">
      <mat-card class="mat-elevation-z8 mt-5 pt-5 pb-5" id="card">
        <h6 class="text-center card-title-page mt-4 mb-4">Edit Account Info:</h6>
        <div class="row d-flex justify-content-center">
          <button
            *ngIf="currentUser.hasRight(['admin', 'manager'])"
            (click)="toggleManageUser()"
            class="edit"
            color="primary"
            mat-icon-button
          >
            <mat-icon>create</mat-icon>
          </button>
          <div class="col-12 col-sm-9 col-sm-offset-1 col-md-9 col-md-offset-1">
            <app-dynamic-form
              *ngIf="questions"
              [questions]="questions"
              [disabled]="!isEdit"
              (formSubmit)="onSubmit($event)"
            >
            </app-dynamic-form>
            <div class="d-flex justify-content-around">
              <a routerLink="/profile/change-password" class="text-decoration-none mt-3">Change Password</a>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
